// ============================================
// FILE 4: stateManagers/store/authStore.ts
// ============================================
import { create } from 'zustand';

export interface User {
  id: string;
  role: string;
  teacher_id?: string;
  student_id?: string;
}

export interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  loading: boolean;
  setAuth: (auth: Partial<AuthState>) => void;
  clearAuth: () => void;
  initAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  user: null,
  accessToken: null,
  refreshToken: null,
  loading: true,

  setAuth: (auth) => {
    console.log('📝 authStore: Updating auth state:', auth);
    set((state) => ({ ...state, ...auth }));
  },

  clearAuth: () => {
    console.log('🧹 authStore: Clearing all auth data');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    set({
      isAuthenticated: false,
      user: null,
      accessToken: null,
      refreshToken: null,
      loading: false,
    });
  },

  initAuth: () => {
    console.log('🚀 authStore: Initializing auth from localStorage...');
    try {
      const accessToken = localStorage.getItem('accessToken');
      const refreshTokenValue = localStorage.getItem('refreshToken');
      const userStr = localStorage.getItem('user');

      if (accessToken && refreshTokenValue && userStr) {
        const user = JSON.parse(userStr);
        console.log('✅ authStore: Restoring authenticated session');
        set({
          isAuthenticated: true,
          user,
          accessToken,
          refreshToken: refreshTokenValue,
          loading: false,
        });
      } else {
        console.log('ℹ️ authStore: No valid session found');
        set({ loading: false });
      }
    } catch (error) {
      console.error('❌ authStore: Error initializing auth:', error);
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      set({
        isAuthenticated: false,
        user: null,
        accessToken: null,
        refreshToken: null,
        loading: false,
      });
    }
  },
}));